import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Eye } from 'lucide-react';
export function VistaPrevia() {
  return <SectionWrapper className="text-center" data-id="element-308">
      <div className="inline-flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-full bg-blue-50 text-blue-600 mb-4 md:mb-6 ring-4 ring-blue-50/50" data-id="element-309">
        <Eye className="w-5 h-5 md:w-6 md:h-6" data-id="element-310" />
      </div>
      <h2 className="text-[20px] md:text-3xl font-bold text-[#0a1f44] mb-2 md:mb-4 tracking-tight" data-id="element-311">
        VISTA PREVIA
      </h2>
      <h3 className="text-[18px] md:text-2xl font-semibold text-slate-800 mb-3 md:mb-4 text-balance" data-id="element-312">
        Explorá el interior del Megapack
      </h3>
      <p className="text-slate-600 max-w-2xl mx-auto text-[14px] md:text-base text-balance" data-id="element-313">
        Conocé la calidad de nuestros protocolos, plantillas y checklists antes
        de tu próxima consulta.
      </p>

      <div className="mt-6 md:mt-10 max-w-4xl mx-auto bg-slate-100 rounded-2xl aspect-video flex items-center justify-center ring-1 ring-slate-900/5 shadow-inner relative overflow-hidden group cursor-pointer" data-id="element-314">
        <div className="absolute inset-0 bg-gradient-to-br from-[#0a1f44]/5 to-[#0a1f44]/10" data-id="element-315"></div>
        <div className="flex flex-col items-center text-slate-400 group-hover:text-blue-600 transition-colors" data-id="element-316">
          <Eye className="w-10 h-10 md:w-12 md:h-12 mb-2 md:mb-3 opacity-50" data-id="element-317" />
          <span className="font-medium text-[14px] md:text-base" data-id="element-318">
            Video / Galería de Vista Previa
          </span>
        </div>
      </div>
    </SectionWrapper>;
}